import { createSelector } from "reselect";
import getAllHotspots from "./getAllHotspots";

const getHotspotId = (_, ownProps) => ownProps.hotspotId || ownProps.cuepointId;

export default function makeGetHotspot() {
  return createSelector(
    [getAllHotspots, getHotspotId],
    (allHotspots, hotspotId) => allHotspots[hotspotId],
  );
}
